import styled from 'styled-components';
import {
  CalendarCancelRegular,
  ArrowLeft20Filled,
} from '@fluentui/react-icons';

export const RequestDetailsHeaderStyle = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0.4rem;

  @media (max-width: 710px) {
    width: 100%;
    height: 10vh;
  }
`;

export const RequestDetailsTitle = styled.p`
  font-size: 20px;
  font-weight: 600;
  color: ${(props) => props.theme.textMainColor};

  @media (max-width: 710px) {
    font-size: 20px;
  }
`;

export const RequestDetailsTitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
`;

export const CalendarCancelLight = styled(CalendarCancelRegular)`
  color: ${(props) => props.theme.cancelCalendarIconColor};
`;

export const ArrowLeft = styled(ArrowLeft20Filled)`
  color: ${(props) => props.theme.textMainColor};

  @media (min-width: 710px) {
    display: none;
  }
`;
